import { config } from "../../../config/config";

const getNodeApiBaseUrl = () =>
  (
    process.env.REACT_APP_NODE_API_URL ||
    config.node_api_url ||
    (window.location.hostname === "localhost" ? "http://localhost:4000" : "")
  ).replace(/\/+$/, "");

const getNodeAuthHeaders = (): Record<string, string> => {
  const idTokenKey = Object.keys(localStorage).find((key) => key.includes("idToken")) as string;
  const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : "";
  const hasuraRole = localStorage.getItem("x-hasura-user-role") || "";
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (idToken) headers.Authorization = `Bearer ${idToken}`;
  if (hasuraRole) headers["x-hasura-role"] = hasuraRole;
  return headers;
};

export const getManualEventLeagueCategory = async (leagueName: string) => {
  const nodeApiBaseUrl = getNodeApiBaseUrl();
  if (!nodeApiBaseUrl) {
    throw new Error("Backend API URL is not configured");
  }

  const response = await fetch(`${nodeApiBaseUrl}/api/getManualEventLeagueCategory`, {
    method: "POST",
    headers: getNodeAuthHeaders(),
    body: JSON.stringify({ leagueName }),
  });
  const responseData = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(responseData?.message || "No matching league category was found for the selected league.");
  }
  if (!responseData?.lc_id) {
    throw new Error("No matching league category was found for the selected league.");
  }
  return responseData as { lc_id: string; lc_name?: string };
};
